// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { popOddsTravelAnimation } from '../actions/oddsTravel';
import OddsTravelAnimationTriggerer from '../components/OddsTravelAnimationTriggerer';
import selectOddsTravelAnimationTriggererProps from '../selectors/specifics/selectOddsTravelAnimationTriggererProps';

type OddsTravelAnimationTriggererContainerProps = {
  className?: string;
};

const OddsTravelAnimationTriggererContainer = (ownProps: OddsTravelAnimationTriggererContainerProps) => {
  const { shouldAnimate, ...selectedProps } = useSelector(selectOddsTravelAnimationTriggererProps);

  const dispatch = useDispatch();

  const popAnimation = useCallback(
    (params: { oddId: number; ts: number }) => {
      dispatch(popOddsTravelAnimation(params));
    },
    [dispatch],
  );

  const otherProps = useMemo(() => ({ popAnimation }), [popAnimation]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return shouldAnimate ? <OddsTravelAnimationTriggerer {...enhancedProps} /> : null;
};

export default OddsTravelAnimationTriggererContainer;
